const dropdownApiValuesConfig = (placeholder, url, uiSemanticsMenuElement, responseCallback) => ({
  fullTextSearch: 'exact',
  placeholder,
  filterRemoteData: true,
  apiSettings: {
    cache: false,
    saveRemoteData: false,
    url,
    dataType: 'html',
    onResponse: function (response) {
      responseCallback(response, uiSemanticsMenuElement)
    }
  }
})

export default dropdownApiValuesConfig
